import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function AvatarText({ label, sx }) {
    return jsx(Wrapper, { sx: sx, children: label });
}
const Wrapper = styled("p")(({ theme }) => ({
    backgroundColor: "transparent",
    color: theme.palette.ui12,
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 1,
    margin: 0,
}));

export { AvatarText };
//# sourceMappingURL=Text.js.map
